import type { IconData } from '@stacksjs/iconify-core'

export const locationPin3: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"m37.5 33.26l.58.032c1.215.068 2.301.733 2.848 1.82a33.5 33.5 0 0 1 2.423 6.38c.44 1.657-.775 3.19-2.487 3.26C37.998 44.87 32.824 45 24 45s-13.998-.13-16.864-.247c-1.712-.07-2.926-1.605-2.487-3.26a33.5 33.5 0 0 1 2.423-6.381c.547-1.087 1.633-1.752 2.848-1.82l.58-.031\"/><path d=\"M39 18.07c0 10.63-10.748 18.26-14.048 20.353a1.77 1.77 0 0 1-1.904 0C19.748 36.331 9 28.7 9 18.07C9 9.747 15.716 3 24 3s15 6.747 15 15.07\"/><path d=\"M30 18a6 6 0 1 1-12 0a6 6 0 0 1 12 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default locationPin3
